import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExitDetailsComponent } from './exit-details.component';


@NgModule({
  declarations: [ExitDetailsComponent],
  imports: [
    CommonModule
  ],
  exports: [
    ExitDetailsComponent
  ]
})
export class ExitDetailsModule { }
